import React from "react"
import ToastProvider from "components/Toast/ToastProvider"
import { DeferredCookiesConsent } from "cookiesConsent"

interface GlobalProvidersProps {
  children: React.ReactNode
}

const GlobalRootProviders = ({ children }: GlobalProvidersProps) => (
  <ToastProvider>
    <DeferredCookiesConsent>{children}</DeferredCookiesConsent>
  </ToastProvider>
)

export default GlobalRootProviders
